import { BookOpenIcon, EyeIcon, MegaphoneIcon, type LucideIcon } from 'lucide-react';

export interface MethodStep {
  n: string;
  title: string;
  icon: LucideIcon;
  text: string;
}

export const methodSteps: MethodStep[] = [
  {
    n: '1',
    title: 'Abre',
    icon: BookOpenIcon,
    text: 'Elige el tomo según tu etapa. Selecciona la sesión que necesitas.'
  },
  {
    n: '2',
    title: 'Mira',
    icon: EyeIcon,
    text: 'Consulta el objetivo, el desarrollo, la variante inclusiva y qué observar.'
  },
  {
    n: '3',
    title: 'Pita',
    icon: MegaphoneIcon,
    text: 'Llévalo directamente al patio. El silbato suena. La sesión comienza.'
  }
];
